import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

/** Opens a profile list (achievements, machines, rewards) in a modal. */
export default function ProfileDialog({
  trigger,
  title,
  description,
  fixedHeight = false,
  children,
}: {
  trigger: ReactNode;
  title: string;
  description: string;
  fixedHeight?: boolean;
  children: ReactNode;
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        className={cn(
          'flex max-h-[85vh] flex-col gap-0 p-0 sm:max-w-2xl',
          fixedHeight && 'h-[min(85vh,720px)]'
        )}
      >
        <DialogHeader className="border-b p-5 pr-12 text-left">
          <DialogTitle className="font-display text-xl font-semibold">
            {title}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
